module.exports = __webpack_public_path__ + "img/akka_logo.2dc41fea.png";